export default String.raw`
{% assign nameWidget = "widgetBanner" -%}

{% if config.Banners[nameWidget] != null -%}
    {% assign bannerWidget = config.Banners[nameWidget].Images[0] -%}
    {% assign bannerWidgetText = bannerWidget.Text -%}
    {% capture bannerWidgetLink -%}{% include 'partials/common/user-link.html', userLink: bannerWidget.Link -%}{% endcapture -%}
    {% assign bannerWidgetHeading = bannerWidget.Heading -%}
    {% assign bannerWidgetAlt = bannerWidget.Alt | H -%}
    {% assign bannerWidgetUrl = bannerWidget.Url -%}
    {% assign bannerWidgetTargetBlank = bannerWidget.TargetBlank -%}
{% endif -%}

{% assign urlSize = bannerWidgetUrl | Size -%}
{% if settings.widgetPosition and urlSize > 0 -%}
    <div role="complementary" class="widget {{ settings.widgetPosition }} widget-js" id="widget">
        <button class="widget__close-js widget__close" aria-label="{{ translations.Close }}" aria-controls="widget" aria-expanded="false">
            <svg aria-hidden="true">
                <use href='css/img/fontawesome-icons.svg?v={{lqTS}}#times-{{ settings.iconStyle }}'></use>
            </svg>
        </button>
        <div tabindex="0" aria-label="{{ bannerWidgetHeading }}" role="button" aria-expanded="false" aria-controls="widget" class="widget__outlier" aria-hidden="false">
            <div class="widget__outlier-content">
                <span>{{ bannerWidgetHeading }}</span>
                <svg class="widget__outlier-content-icon">
                    <use href='css/img/fontawesome-icons.svg?v={{lqTS}}#chevron-right-{{ settings.iconStyle }}'></use>
                </svg>
            </div>
        </div>
        <div class="widget__image">
            <img src="{{bannerWidgetUrl}}" alt="{{bannerWidgetAlt | H}}" loading="eager" fetchpriority="high">
        </div>
        <div class="widget__content">
            {% assign textSize = bannerWidgetText | Size -%}
            {% if textSize > 0 -%}
                <p>{{ bannerWidgetText }}</p>
            {% endif -%}
            {% assign linkSize = bannerWidgetLink | Size -%}
            {% if linkSize > 0 -%}
                <a tabindex="-1" class="widget__content-button primary-action-button" href="{{ bannerWidgetLink }}" {% if bannerWidgetTargetBlank -%}target="_blank"{% endif -%}>
                    {{translations.Look}}
                </a>
            {% endif -%}
        </div>
    </div>
{% endif -%}
`